<template>
  <Modal
    v-model:show="active"
    :close-modal-bottom="true"
    :style="{ backgroundImage: 'url(' + preview + ')' }"
    class="media-preview"
    footer-classes="!tw-justify-start"
  >
    <div class="col-12 !tw-text-center mt-0">
      <div ref="preview" />
    </div>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import watermarkImg from '@/assets/img/watermark.svg';

export default {
  components: {
    Modal,
  },
  emits: ['openBanner', 'closeBanner'],
  data() {
    return {
      active: false,
      data: {},
      preview: watermarkImg,
      loading: true,
      popup: true,
    };
  },


  watch: {
    active() {
      if (!this.active) {
        this.$refs.preview.innerHTML = '';
        this.$emit('closeBanner', true);
      }
    },
  },
  methods: {
    open(item) {
      const { id, src } = this.parseScriptData(item);
      this.loadScript(id, src);

      this.active = true;
      this.$emit('openBanner', true);
    },

    parseScriptData(script) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(script, 'text/html');
      const scriptTag = doc.querySelector('script');

      return {
        id: scriptTag.id,
        src: scriptTag.src,
      };
    },

    loadScript(id, src) {
      const script = document.createElement('script');
      script.src = src;
      script.id = id;
      script.async = true;

      this.$refs.preview.appendChild(script);
    },
  },
};
</script>

<style lang="scss">
.media-preview {
  background-size: 36px;

  .modal-dialog {
    min-width: 100%;
    display: flex;
    margin: 0 !important;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .modal-header {
    border: none;
    padding-right: 15px !important;

    button {
      color: #fff;
      font-size: 48px;
      padding-bottom: 0 !important;
    }
  }

  .modal-content {
    max-width: max-content;
    background: transparent;
    border-radius: 0px !important;
  }

  .modal-footer {
    display: none;
  }

  @media (max-width: 650px) {
    .modal-dialog {
      max-width: 100%;
      width: 100%;
      float: none;

      .modal-header {
        padding-right: 0 !important;
      }

      .modal-body {
        .col-12 {
          padding: 0;

          > div {
            overflow: auto;
            max-height: calc(100vh - 120px);
            max-width: calc(100vw - 32px);
          }
        }
      }
    }
  }
  @media (max-height: 750px) {
    .modal-dialog {
      .modal-body {
        margin-top: 30px;
      }
    }
  }
}
</style>
